import { useRestApiHeaders } from 'business/contextProviders/useApiHeaders';
import { useRepairReportPictureV1ControllerGetByRepair } from 'generated/apiComponents';
import { Module_Enum } from 'generated/graphql';

export const useGetRepairReportPicturesData = (repairId: string | null) => {
  const restHeaders = useRestApiHeaders(Module_Enum.QualityControl);

  const { data, error, isLoading } =
    useRepairReportPictureV1ControllerGetByRepair(
      {
        queryParams: {
          repairId: repairId ?? '',
        },

        headers: restHeaders,
      },
      {
        enabled: !!repairId,
      },
    );

  return {
    data,
    isLoading,
    error,
  };
};
